<template>
    <v-card @click="Open"
            elevation="4"
            color="purple darken-2"
            dark
            class="text-sm-center"
            style="cursor:pointer;">
        <v-card-title>
            <h2 class="mx-auto my-0">Here to Help</h2>
        </v-card-title>
        <v-card-title>
            <v-icon large class="mx-auto my-0">far fa-comments</v-icon>
        </v-card-title>
        <v-card-text>
            <h3 class="mb-4 text-center">If you require any assistance with your learner journey, please contact our Help Point team</h3>
            <div class="text-center">We are open between:<br />8:30am - 4:30pm, Monday-Friday</div>
            <div class="text-center">You can contact us:</div>
            <div class="text-center">Tel: 0300 123 1036</div>
            <div class="text-center">Email: <a href="mailto:heretohelp@dundeeandangus.ac.uk" style="color:white !important;text-decoration:underline;">heretohelp@dundeeandangus.ac.uk</a></div>
            <div class="text-center">Live Chat: <a href="http://www.dundeeandangus.ac.uk" target="_blank" style="color:white !important;text-decoration:underline;">www.dundeeandangus.ac.uk</a></div>
            <div class="text-center">WhatsApp: <a href="https://wa.link/irqwkb" target="_blank" style="color:white !important;text-decoration:underline;">07725 213 174</a></div>
        </v-card-text>
        <v-card-actions>
            <v-btn dark text block>Click here for more information</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import ctrlOpenMixin from '@/views/components/mixins/base/ctrlOpen.js'

    export default {
        mixins: [ctrlOpenMixin],
        methods: {
            Open() { this.CtrlOpen('/here-to-help'); }
        },
    }
</script>
